import { render, staticRenderFns } from "./deleteAlert.vue?vue&type=template&id=c7049dfe&"
import script from "./deleteAlert.vue?vue&type=script&lang=js&"
export * from "./deleteAlert.vue?vue&type=script&lang=js&"
import style0 from "./deleteAlert.vue?vue&type=style&index=0&id=c7049dfe&prod&sc=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports